//import "es5-shim";
import "intl-tel-input";
import jQuery from "jquery";
import Fingerprint from "fingerprintjs2";

import FormValidator from "./validation/FormValidator";
import AjaxFormSubmitter from "./AjaxFormSubmitter";
import IframeDataSource from "./data/IframeDataSource";
import FacebookHelper from "./util/FacebookHelper";
import FormUtil from "./FormUtil";
import Hash from "./Hash";
import LanguageSelector from "./LanguageSelector";

import GoogleAnalyticsHelper from "./util/GoogleAnalyticsHelper";
import GTMHelper from "./util/GTMHelper";

(function() {
  if (typeof NodeList.prototype.forEach === "function") return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

export default class App {
  constructor(options) {
    this.setErrOperationKeys();
    this.fbLoginDetails = null;

    const gaHelper = new GoogleAnalyticsHelper.getInstance(),
      facebookHelper = new FacebookHelper({
        appId: "375970675824752"
      }),
      langSelector = new LanguageSelector(),
      formUtil = new FormUtil(),
      hash = new Hash(),
      dataSource = new IframeDataSource({
        url: options.url.iframe
      }),
      submitter = new AjaxFormSubmitter(dataSource),
      splitResponseCode = str => {
        const pattern = /^[A-Z]{2,3}\-\d{4,}/,
          code = pattern.exec(str),
          message = str.replace(pattern, "");
        return {
          code: code,
          message: message
        };
      },
      formConfigurationMap = {
        "signup.json": {
          onResponse: response => {
            if (response.success) {
              hash.set("verify/phone");
            } else {
              throw {
                message: response.operationMessage || "Something went wrong!"
              };
            }
          },
          onData: (data, form) => {
            const split = data.name.split(/\s+/),
              countryData = jQuery(form.phoneNumber).intlTelInput(
                "getSelectedCountryData"
              );
            return callback => {
              window.recaptchaCallBack = () => {
                callback({
                  firstName: split[0],
                  lastName: split[1],
                  userEmail: data.email,
                  password: data.password,
                  phoneNumber: data.phoneNumber,
                  sex: 1,
                  birthday: "",
                  promoCode: data.code || "",
                  userCompanyName: "",
                  countryCode: countryData.dialCode,
                  deviceId: fingerprint
                });
                delete window.recaptchaCallBack;
              };
              grecaptcha.execute();
            };
          }
        },

        "signUpFacebook.json": {
          onResponse: response => {
            if (response.success) {
              hash.set("verify/phone");
            } else {
              throw {
                message: response.operationMessage || "Something went wrong!"
              };
            }
          },
          onData: (data, form) => {
            let countryData = jQuery(form.phoneNumber).intlTelInput(
              "getSelectedCountryData"
            );
            if (!this.fbLoginDetails) {
              console.log(
                "Data lost due to page reload, need to signup using fb again."
              );
              //form.preventDefault()
              return false;
            }

            return callback =>
              callback({
                firstName: this.fbLoginDetails.firstName || "",
                lastName: this.fbLoginDetails.lastName || "",
                email: data.email || "",
                password: "",
                phoneNumber: data.phoneNumber,
                sex: this.fbLoginDetails.sex || 1,
                dateOfBirth: "",
                promoCode: data.code || "",
                userCompanyName: "",
                countryCode: countryData.dialCode,
                facebookId: this.fbLoginDetails.facebookId || "",
                accessToken: this.fbLoginDetails.accessToken || ""
              });
          }
        },

        "verifySignupCode.json": {
          onResponse: response => {
            if (response.success) {
              GTMHelper.raiseEvent({
                event: "custom_event",
                eventCategory: "signup_flow",
                eventAction: "signup_mobile", // TODO: In case of signup with facebook, set this to signup_facebook
                eventLabel: "successful_account_created"
              });
              window.location.href = options.url.success;
            } else {
              throw {
                message:
                  this.errOperationKeys[
                    "TEXT_ERROR_INVALID_VERIFICATION_CODE"
                  ] || "Please enter valid verification code"
              };
            }
          }
        },

        "generateSignUpSMSCode.json": {
          onResponse: response => {
            if (!response.success) {
              throw {
                message: "Unable to generate the code"
              };
            }
          }
        }
      };

    document.querySelectorAll("form[action]").forEach(form => {
      new FormValidator(form);

      const formInfo = submitter.getFormInfo(form),
        formConfig = formConfigurationMap[formInfo.url];

      form.addEventListener("submit", event => {
        formUtil
          .freeze(document.body, true)
          .addSpinner(form.querySelector(".btn-primary"), true)
          .formError(form);

        submitter.submit(
          response => {
            formUtil
              .freeze(document.body, false)
              .addSpinner(form.querySelector(".btn-primary"), false);

            if (response.status.code == 200) {
              try {
                formConfig.onResponse(response.response);
              } catch (e) {
                const split = splitResponseCode(e.message),
                  code = split.code,
                  operationKey = response.response
                    ? response.response.operationKey
                    : undefined,
                  message =
                    operationKey && this.errOperationKeys[operationKey]
                      ? this.errOperationKeys[operationKey]
                      : split.message;
                if (operationKey) {
                  const opKeyToErrorPageMap = {
                      INVALID_PHONE: "invalid/phone",
                      DEVICE_LIMIT_ERROR: "device-limit",
                      TEXT_ERROR_SIGNUP_ALREADY_EXIST: "in-use/phone",
                      TEXT_ERROR_PROVIDE_EMAIL_ADDRESS_ALREADY_EXISTS:
                        "in-use/email",
                      SIGNUP_PROMOCODE_INVALID: "invalid/promo",
                      TEXT_ERROR_MESSAGE_SIGNUP: "other",
                      TEXT_ERROR_INVALID_VERIFICATION_CODE: "invalid/code"
                    },
                    errorPage = opKeyToErrorPageMap[operationKey];

                  if (errorPage) {
                    gaHelper.pageview("air/error/" + errorPage);
                  }
                }
                formUtil.formError(form, message);
              }
            } else {
              formUtil.formError(
                form,
                this.errOperationKeys["ERROR_MSG_UNEXPECTED_RESPONSE"]
              );
            }
          },
          {
            form: form,
            onData: formConfig.onData
          }
        );
      });

      form.addEventListener("change", event => {
        formUtil.formError(form, "");
      });
    });

    document.querySelectorAll(".lnk-show-inv").forEach(item => {
      item.addEventListener("click", event => {
        const label = event.target.parentElement,
          fieldContainer = label.previousElementSibling;
        fieldContainer.style.display = "";
        label.parentElement.removeChild(label);
        fieldContainer.querySelector("input").focus();
      });
    });

    const fbButton = document.querySelector(".btn-fb");
    fbButton.addEventListener("click", event => {
      formUtil.freeze(document.body, true).addSpinner(fbButton, true);
      facebookHelper.login((loginResponse, dataResponse) => {
        if (!dataResponse) {
          formUtil.freeze(document.body, false).addSpinner(fbButton, false);
          return;
        }
        let signupForm = document.querySelector('form[action="signup.json"]');
        let countryData = jQuery(
          signupForm.querySelector('input[name="phoneNumber"]')
        ).intlTelInput("getSelectedCountryData");

        this.fbLoginDetails = {
          password: "",
          phoneNumber: "",
          dateOfBirth: "",
          promoCode: "",
          userCompanyName: "",
          countryCode:
            countryData && countryData.dialCode ? countryData.dialCode : "",
          facebookId:
            loginResponse.authResponse && loginResponse.authResponse.userID
              ? loginResponse.authResponse.userID
              : "",
          accessToken:
            loginResponse.authResponse && loginResponse.authResponse.accessToken
              ? loginResponse.authResponse.accessToken
              : ""
        };
        if (dataResponse) {
          let nameArray = dataResponse.name.split(" ");
          this.fbLoginDetails.firstName = nameArray[0];
          this.fbLoginDetails.lastName = nameArray[1];
          this.fbLoginDetails.email = dataResponse.email;
          if (
            dataResponse.gender &&
            dataResponse.gender.toString().toLowerCase() === "male"
          ) {
            this.fbLoginDetails.sex = 1;
          } else {
            this.fbLoginDetails.sex = 2;
          }
        }

        dataSource.request(
          () => {
            formUtil.freeze(document.body, false).addSpinner(fbButton, false);
            hash.set("continue-with-facebook");
          },
          {
            enctype: "application/json",
            url: "setSessionForSignup.json",
            data: this.fbLoginDetails
          }
        );
      });
    });

    //////////////// Deffered Tasks ////////////////

    window.setTimeout(() => {
      const hash = window.location.hash;
      let usersCountry = "";
      let promoCode = "";
      if (hash.indexOf("countryCode") > -1) {
        usersCountry = hash.substr(hash.indexOf("countryCode") + 12, 2);
        if (usersCountry) {
          usersCountry = usersCountry.toLowerCase();
          if (options.preferredCountries.indexOf(usersCountry) == -1) {
            usersCountry = options.preferredCountries[0];
          }
        }
      }

      jQuery("input[type=tel]").each(function(index) {
        const telInput = jQuery(this),
          telInputContainer = telInput.parents(".field-container");

        telInput
          .on("keyup", function() {
            let val = this.value.trim();
            if (val.indexOf("+") == 0) {
              let countryData = jQuery(this).intlTelInput(
                "getSelectedCountryData"
              );
              if (
                countryData.dialCode &&
                val.indexOf("+" + countryData.dialCode) == 0
              ) {
                this.value = this.value.replace("+" + countryData.dialCode, "");
              }
            }
          })
          .intlTelInput({
            utilsScript: "../js/intl-tel-input-utils.js",
            autoPlaceholder: true,
            separateDialCode: true,
            preferredCountries: options.preferredCountries,
            initialCountry: usersCountry
          });

        if (telInput.attr("data-focus-later")) {
          telInput.removeAttr("data-focus-later");
          telInput.attr("focus-by-js", true);
          telInput.focus();
        }
      });

      if (hash.indexOf("promoCode") > -1) {
        promoCode = hash.substr(hash.indexOf("promoCode") + 10);
        if (promoCode.indexOf("&") > -1) {
          promoCode = promoCode.split("&")[0];
        } else if (promoCode[promoCode.length - 1] == "/") {
          promoCode = promoCode.slice(0, -1);
        }
        const $wrapper_invitationCodeAnchor = document
          .querySelector("#sec-sign-up")
          .querySelector(".lnk-show-inv").parentElement;
        const $wrapper_invitationCodeField =
          $wrapper_invitationCodeAnchor.previousElementSibling;
        $wrapper_invitationCodeAnchor.style.display = "none";
        $wrapper_invitationCodeField.style.display = "block";
        $wrapper_invitationCodeField.querySelector(
          "input"
        ).value = decodeURIComponent(promoCode);
      }
      langSelector.initAll();
    }, 0);

    let fingerprint;
    window.setTimeout(() => {
      const fingerprintGenerator = new Fingerprint();
      fingerprintGenerator.get(result => {
        fingerprint = result;
      });
    }, 1000);
  }

  setErrOperationKeys() {
    this.errOperationKeys = {};
    document
      .querySelectorAll("span[data-operationKey]")
      .forEach(operationMsg => {
        this.errOperationKeys[operationMsg.getAttribute("data-operationKey")] =
          operationMsg.innerText;
      });
  }
}
